module.exports = __webpack_public_path__ + "img/TA.188e2d36.svg";